import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useGuardian, useRouter, useTranslate } from "@bluelibs/x-ui";
import { useState } from "react";
import { Form, Input, Button, Row, Col, Alert } from "antd";
export function ForgotPassword() {
    const guardian = useGuardian();
    const router = useRouter();
    const t = useTranslate();
    const tl = useTranslate("authentication.forgotPassword");
    const [submitError, setSubmitError] = useState(null);
    const [isCompleted, setIsComplete] = useState(false);
    const onSubmit = (data) => {
        guardian
            .forgotPassword(data.email)
            .then(() => {
            setIsComplete(true);
        })
            .catch((err) => {
            setSubmitError(err.toString());
        });
    };
    const style = { minHeight: "100vh" };
    return (_jsx(Row, Object.assign({ justify: "center", align: "middle", style: style, className: "forgot-password-page" }, { children: _jsxs(Col, Object.assign({ span: 20, md: 12, lg: 8 }, { children: [isCompleted && _jsx(Alert, { type: "success", message: tl("success") }, void 0), !isCompleted && (_jsxs(Form, Object.assign({ onFinish: (data) => onSubmit(data), className: "authentication-form" }, { children: [_jsx("img", { src: "/public/wp-energy-logo-2.png", alt: "wpenergy-logo", className: "login-page-logo" }, void 0), _jsx(Form.Item, Object.assign({ name: "email", rules: [{ required: true }], className: "forgot-password-page-item" }, { children: _jsx(Input, { placeholder: tl("fields.email") }, void 0) }), void 0), _jsx(Form.Item, { children: _jsx(Button, Object.assign({ type: "primary", htmlType: "submit", className: "authentication-form-button" }, { children: tl("submit") }), void 0) }, void 0), submitError && (_jsx(Alert, { message: t("generics.error"), type: "error" }, void 0))] }), void 0))] }), void 0) }), void 0));
}
